import { Box, BoxProps } from "@chakra-ui/react";
export function MultiAIIcon({ ...props }: BoxProps) {
  return (
    <Box {...props}>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3.33333 16.6663C2.875 16.6663 2.48264 16.5031 2.15625 16.1768C1.82986 15.8504 1.66667 15.458 1.66667 14.9997V4.99967C1.66667 4.54134 1.82986 4.14898 2.15625 3.82259C2.48264 3.4962 2.875 3.33301 3.33333 3.33301H16.6667C17.125 3.33301 17.5174 3.4962 17.8438 3.82259C18.1701 4.14898 18.3333 4.54134 18.3333 4.99967V14.9997C18.3333 15.458 18.1701 15.8504 17.8438 16.1768C17.5174 16.5031 17.125 16.6663 16.6667 16.6663H3.33333ZM3.33333 14.9997H16.6667V6.66634H3.33333V14.9997ZM6.25 14.1663L5.08333 12.9997L7.22917 10.833L5.0625 8.66634L6.25 7.49967L9.58333 10.833L6.25 14.1663ZM10 14.1663V12.4997H15V14.1663H10Z"
          fill="currentColor"
        />
      </svg>
    </Box>
  );
}
